import type { TaxonomyEntry } from 'src/redux/content/types';
import type { TaxonomyPlpNeighborhoodEntry } from 'src/services/contentstack/taxonomyNeighborhood/types';

/**
 * Union-merges a fetched neighbourhood map into the existing entries by `url`.
 * Existing entries are kept unchanged (preserving any loaded `content`); map
 * entries whose url is not already present are appended as `{ url, indexable }`.
 */
export const mergeNeighborhoodMapIntoEntries = (
  entries: TaxonomyEntry[],
  mapEntries: TaxonomyPlpNeighborhoodEntry[],
): TaxonomyEntry[] => {
  const existingUrls = new Set(entries.map((entry) => entry.url));
  const additions = mapEntries
    .filter((mapEntry) => !existingUrls.has(mapEntry.url))
    .map((mapEntry) => ({ url: mapEntry.url, indexable: mapEntry.indexable }));

  return [...entries, ...additions];
};
